import { urlJoin } from './url-utils';
import { general, urlAuth } from '../settings';

export default {
    ROOT: `${process.env.PUBLIC_URL}/`,
    LOGIN: (uri) => `${urlAuth}/authorize?client_id=${general.client_id}&redirect_uri=${uri}&response_type=code&scope=ead`,
    LOGOUT: (uri) => `${urlAuth}/logout?client_id=${general.client_id}&redirect_uri=${uri}`,
    HOME: `${process.env.PUBLIC_URL}/home`,
    COACH_CLASSES: `${process.env.PUBLIC_URL}/home`,
    RESOURCES: (...ids) => urlJoin(`${process.env.PUBLIC_URL}/courses`, ...ids),
    SCIS_REDIRECTION: `${process.env.PUBLIC_URL}/scis-redirect/:code`,
};



// WEBPACK FOOTER //
// ./src/utils/routes.js